import React from 'react';
import { lowerCase as _lowerCase } from "lodash";
import {Link, withRouter} from "react-router-dom";

class LogoFooter extends React.PureComponent {  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    let hostparts = window.location.hostname.split(".");
    let sub = _lowerCase(hostparts.shift());
    let logoFooter = document.getElementById("Logo-footer");
    if(sub !== "localhost" && sub !== "cleanfi"){
      logoFooter.classList.add("active-logo");
      logoFooter.style.display = "flex";
    }
  }

  render () {
      return(
       <Link to="/" className="full-width" id="Logo-footer">
          <div
              className={`logo-footer-wrapper ${this.props.mode === "light" ? "light" : ""} ${this.props.align === "left" ? "left" : ""} ${this.props.className || ''}` }
              style={this.props.style ? {...this.props.style} : null}
          >
          {this.props.mode === "light" ? (
              <img src="https://statichouse.pacefi.com/logos/Logo_CleanFi_lotus_white.svg"/>
              ) : (
                <img src="https://statichouse.pacefi.com/logos/Logo_CleanFi_lotus_black.svg" />
                  )
            }
              <p>CleanFi Network Member</p>
          </div>
       </Link>
      )
  }
}
export default LogoFooter;